<template>
    <div>
        <Header>
            <div class="filter-box filter-box--full">
                <div class="filter-box__left">
                    <div class="search-box">
                        <input type="text" v-model="search_term" placeholder="Filter Articles...">
                    </div>
                </div>
            </div>
        </Header>

        <div class="page" >

            <div class="alert" v-if="portfolio&&portfolio.account_type!='pro'&&portfolio.account_type!='unlimited'">
                <i class="material-icons">warning</i>
                <p>
                    <span v-t="'Your plan does not include article backups.'"></span> <router-link :to="{name: 'account'}"><span v-t="'Upgrade to enable'"></span> &rarr;</router-link>
                </p>
            </div>

            <div class="block">
                <h3 class="block__heading" v-t="'Article Backups'"></h3>
                <p v-t="'pages.article-backups-desc'"></p>
            </div>

            <div class="page-tags__wrapper">
                <div class="page-tags" :class="{'open': viewAllTags}">
                    <span class="article-tag" @click="clickTag(tag)" v-show="tag.tag!='All'" :class="{'deactive': notTagActive(tag.id)}" v-bind:key="tag.tag" v-for="tag in tags">
                        {{tag.tag}}
                        <span class="article-tag__remove" ><i class="material-icons">close</i></span>
                    </span>
                </div>

                <a class="page-tags--all" v-if="tags.length>6&&!viewAllTags" @click="viewAllTags=true">Show all tags <i class="material-icons">arrow_drop_down</i></a>
            </div>


            <table class="editor-table">
                <thead>
                    <tr>
                        <th v-t="'Article'"></th>
                        <th v-t="'Status'"></th>
                        <th v-t="'Backup Screenshot'"></th>
                        <th v-t="'Backup PDF'"></th>
                        <th v-t="'Article Link'"></th>
                    </tr>
                </thead>
                <tbody v-if="!articles">
                    <tr>
                        <td colspan="100%">
                            <div class="loading-gif" >
                                <img :src="VUE_APP_STATIC_URL + 'img/loading.gif'">
                            </div>
                        </td>
                    </tr>
                </tbody>
                <tbody v-if="articles">
                    <tr v-bind:key="article.id" v-for="article in articlesWithBackups">
                        <td>
                            <div v-if="article.image" class="img" :style="{'background-image': 'url('+article.image.image+')'}"></div>
                            <div v-if="!article.image" class="img" ></div>
                            <div class="img-text img-text--max">
                                <router-link :to="{name: 'article', params: {id: article.id}}">{{article.title}}</router-link>
                                <span class="page-restricted" v-if="article.restricted"><i class='material-icons'>warning</i></span>
                                <span class="ellipsis grey">{{article.publication_name}} &bullet;
                                    <span v-if="article.item_type=='url'" v-t="'URL Link'"></span>
                                    <span v-if="article.item_type=='file'" v-t="'Uploaded File'"></span>
                                    <span v-if="article.item_type=='blog'" v-t="'Written article'"></span>  &bullet; {{article.published_date}}
                                </span>

                            </div>
                        </td>
                        <td>
                            <span key="backup-1" v-if="article.backup"><span v-t="'Backed Up'"></span></span>
                            <span key="backup-2" v-if="!article.backup"><span v-t="'Not Backed Up'"></span></span>
                        </td>
                        <td>
                            <a key="backup-3" v-if="article.backup" :href="article.backup" target="_blank"><span v-t="'View Screenshot'"></span></a>
                            <a key="backup-4" v-if="!article.backup&&!article.backing_up&&(portfolio.account_type=='pro'||portfolio.account_type=='unlimited')" @click="backup(article)"><span v-t="'Queue Backup'"></span></a>
                            <span  key="backup-5" v-if="!article.backup&&article.backing_up"><span v-t="'Queued for backup...'"></span></span>
                        </td>
                        <td>
                            <a key="backup-6" v-if="article.backup&&article.backup_pdf" :href="article.backup_pdf" target="_blank"><span v-t="'View PDF'"></span></a>
                            <a key="backup-7" v-if="!article.backup&&!article.backing_up&&(portfolio.account_type=='pro'||portfolio.account_type=='unlimited')" @click="backup(article)"><span v-t="'Queue Backup'"></span></a>
                            <span key="backup-8" v-if="!article.backup&&article.backing_up"><span v-t="'Queued for backup...'"></span></span>
                        </td>
                        <td>
                            <span v-if="article.backup">
                                <select @change="saveBackupOption(article.id, article.backup_option)" v-model="article.backup_option">
                                    <option value="url" v-t="'Use URL'"></option>
                                    <option value="pdf" v-t="'Use PDF Backup'"></option>
                                    <option value="png" v-t="'Use Image Backup'"></option>
                                </select>
                            </span>
                        </td>
                    </tr>
                    <tr v-if="articles.length==0">
                        <td colspan="100%" v-t="'No Backups yet. Click \'Add Article\' to get started.'">

                        </td>
                    </tr>
                </tbody>
                <tfoot v-if="articles">
                    <td colspan="100%">
                        {{articlesWithBackups.length}} <span v-t="'Backups'"></span>
                    </td>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    export default {
        components: {
            Header
        },
        data () {
            return {
                VUE_APP_STATIC_URL: process.env.VUE_APP_STATIC_URL,
                search_term: '',
                tags: [],
                articles: null,
                active_tags: [],
                loadingArticles: false,
                viewAllTags: false
            }
        },
        computed: {
            portfolio () {
                return this.$store.getters['portfolio/portfolio']
            },
            articlesWithBackups (){
                var backups = []
                for (var i=0; i<this.articles.length; i++){
                    if (this.articles[i].item_type === 'url') {
                        backups.push(this.articles[i])
                    }
                }
                return backups
            }
        },
        methods: {
            notTagActive (tag_id) {
                return this.active_tags.indexOf(tag_id) === -1
            },
            clickTag (tag) {
                if(this.active_tags.indexOf(tag.id) === -1){
                    this.active_tags.push(tag.id)
                }else{
                    this.active_tags.splice(this.active_tags.indexOf(tag.id), 1)
                }
                this.updateArticles(0)
            },
            backup (article) {
                article.backing_up = true;
                this.$http.post('/articles/'+article.id+'/backup/', {}).then(data => {
                    this.$store.dispatch('messages/success', this.$t('messages.article-backup-queued'))
                }).catch(errors => {
                    this.errors = errors.response.data
                })
            },
            saveBackupOption (article_id, option) {
                this.$http.put('/articles/'+article_id+'/backup-status/', {backup_option: option}).then(data => {
                    this.$store.dispatch('messages/success', this.$t('messages.article-backup-changed'))
                }).catch(errors => {
                    this.errors = errors.response.data
                })
            },
            updateArticles (start_at) {
                var items = [];
                if(this.active_tags.length !== 0){
                    items.push('tags='+this.active_tags.join(','));
                }
                if(this.search_term && this.search_term !== ''){
                    items.push('search='+this.search_term);
                }
                if(start_at !== 0){
                    items.push('start_at='+start_at);
                }

                this.$http.get('/articles/?'+items.join('&')).then(data => {
                    if(start_at === 0){
                        this.articles = data.data
                    }else{
                        this.loadingArticles = false
                        this.articles = this.articles.concat(data.data)
                    }
                })
            },
            handleScroll () {
                var documentHeight = Math.max( document.body.scrollHeight, document.body.offsetHeight,
                 document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight );

                if((window.scrollY + window.innerHeight) > documentHeight - 400){
                    if(!this.loadingArticles){
                        this.loadingArticles = true
                        this.updateArticles(this.articles.length)
                    }
                }
            },
        },
        watch: {
            search_term () {
                this.updateArticles(0);
            }
        },
        beforeDestroy () {
            document.removeEventListener('scroll', this.handleScroll);
        },
        mounted () {
            this.$http.get('/articles/').then(data => {
                this.articles = data.data;
                document.addEventListener('scroll', this.handleScroll);
            })
            this.$http.get('/tags/').then(data => {
                this.tags = data.data;
            })
        }
    }
</script>